"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _SvgIcon = _interopRequireDefault(require("../SvgIcon/SvgIcon"));

var BtnArrowDown = function BtnArrowDown(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.533 4.997c.13.006.26-.039.357-.136L8.925.826a.488.488 0 0 0-.69-.69L4.532 3.843.826.137a.488.488 0 0 0-.69.69L4.172 4.86c.097.097.23.143.362.136z"
  }));
};

BtnArrowDown.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9.0618038 4.9977479"
};

var AccordionChevron = function AccordionChevron(_ref) {
  var isOpen = _ref.isOpen,
      isActive = _ref.isActive,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], {
    svg: BtnArrowDown,
    className: (0, _classnames["default"])('relative', className, {
      'transform-180': isOpen
    }),
    height: 9,
    width: 9,
    color: isOpen || isActive ? 'blue' : 'gray-dark',
    "data-qa": "accordion-chevron"
  });
};

AccordionChevron.defaultProps = {
  isActive: false,
  className: ''
};
AccordionChevron.propTypes = {
  /** Indicator whether or not collapse should be open */
  isOpen: _propTypes["default"].bool.isRequired,

  /** Indicator whether or not we are in active state */
  isActive: _propTypes["default"].bool,

  /** Additional class name to chevron */
  className: _propTypes["default"].string
};
var _default = AccordionChevron;
exports["default"] = _default;